import compressCamera from 'helpers/projects/compressCamera'
import compressFloorPlan from 'helpers/projects/compressFloorPlan'
import compressEntities from 'helpers/projects/compressEntities'
import extractMapDependencies from 'helpers/projects/extractMapDependencies'
import merge from 'ramda/src/merge'
import omit from 'ramda/src/omit'

const compressMarkup = omit(['overlay', 'remove'])
const compressUi = omit(['modal', 'scaling', 'drawingWall', 'drawingWire', 'floorPlanScaleID', 'deviceLimitType', 'mapLoaded',
  'measurementTool', 'drawingMeasurement', 'highlightAddNetworkCloset', 'offlineTimeLimit'])
const compressTopLevelKeys = omit(['manufacturerSpecificCameraModels'])

export default ({ currentEntity, project, cameras, mapLocation, zoom, ui, title, mapType, floorPlans, markups, updatedAt, entities }) =>
  merge(
    extractMapDependencies(
      merge(
        compressTopLevelKeys(project),
        { mapLocation, zoom, mapType }
      )
    ),
    {
      cameras: cameras.map(compressCamera),
      map: {
        floorPlans: floorPlans.map(compressFloorPlan),
        markups: markups.map(compressMarkup)
      },
      entities: compressEntities(entities),
      ui: compressUi(ui),
      currentEntity,
      title,
      updatedAt
    }
  )



// WEBPACK FOOTER //
// ./src/helpers/projects/compressProject.js